import AddressLookup from '../fields/address-lookup.js';
import Recaptcha from '../fields/recaptcha.js';
import DatePicker from '../fields/date-picker.js';
import DealerLeadCodes from '../fields/dealer-lead-codes.js';
import DealerInfo from '../fields/dealer-info.js';
import DealerSearch from '../fields/dealer-search.js';
import FormField from '../fields/field.js';
import SavedFormField from '../fields/saved-form-field.js';
import GAClientID from '../fields/ga-client-id.js';
import AccountID from '../fields/account-id';
import DealerAppointment from '../fields/dealer-appointment.js';
import Button from '../fields/button.js';
import CarLeadTime from '../fields/car-lead-time.js';
import DealerDetails from '../fields/dealer-details.js';
import SavedCar from '../fields/saved-car.js';
import CreateWishlist from '../fields/create-wishlist.js';
import AddressHistory from '../fields/address-history.js';
import EmploymentHistory from '../fields/employment-history.js';
import EmploymentDetails from '../fields/employment-details.js';
import BankDetails from '../fields/bank-details.js';
import BankDetailsResponse from '../fields/bank-details-response.js';
import HighValueLeads from '../fields/high-value-leads';
import SearchableDropdown from '../fields/searchable-dropdown';

export default class FieldFactory {
    static get Fields() {
        return [
            AddressLookup,
            Recaptcha,
            DatePicker,
            DealerLeadCodes,
            DealerInfo,
            DealerSearch,
            SavedFormField,
            GAClientID,
            AccountID,
            DealerAppointment,
            Button,
            CarLeadTime,
            DealerDetails,
            SavedCar,
            CreateWishlist,
            AddressHistory,
            EmploymentHistory,
            EmploymentDetails,
            BankDetails,
            BankDetailsResponse,
            HighValueLeads,
            SearchableDropdown,
        ];
    }

    static build(parent, el) {
        const Field = this.Fields.find((F) => F.is(el));
        return Field ? new Field(parent, el) : new FormField(parent, el);
    }
}
